import { Spinner } from '@fluentui/react-components';

export const LoadingSpinner: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px',
      }}
    >
      <Spinner size="medium" label="Laden..." />
    </div>
  );
};
